<template>
  <el-scrollbar>
    <el-menu router class="layout-menu system-scrollbar" :collapse="isMobile" :class="isMobile? 'collapse': ''" :unique-opened="true" :default-active="activeMenu">
      <template v-for="menu in menuList" v-bind:key="menu">
        <template v-if="!menu.hideMenu">
          <el-sub-menu v-if="hasChildren(menu)" :index="menu.path">
            <template #title>
              <el-icon v-if="menu.meta&&menu.meta.icon"><component :is="menu.meta.icon || 'el-icon-menu'"/></el-icon>
              <span>{{menu.meta.title}}</span>
            </template>
            <template v-for="(item, key) in menu.children" :key="key">
              <el-menu-item :index="menu.path+'/'+item.path" v-if="!item.meta.auth || item.meta.auth == userId">
                <el-icon v-if="item.meta&&item.meta.icon"><component :is="item.meta.icon || 'el-icon-menu'"/></el-icon>
                <span>{{item.meta.title}}</span>
              </el-menu-item>
            </template>
          </el-sub-menu>
          <el-menu-item v-else :index="'/'+menu.children[0].path">
            <el-icon v-if="menu.children[0].meta&&menu.children[0].meta.icon"><component :is="menu.children[0].meta.icon || 'el-icon-menu'"/></el-icon>
            <span>{{menu.children[0].meta.title}}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'

export default {
  data() {
    return {
      activeMenu: ''
    }
  },
  watch:{
    $route(e) {
      this.activeMenu = e.path
		}
	},
  methods:{
    hasChildren(item){
      return item.children.length > 1?true:false;
    }
  },
  created(){
    this.activeMenu = useRoute().path
  },
  computed:{
    menuList(){
			return useRouter().options.routes
		},
    isMobile(){
      return this.$store.state.app.isMobile;
    },
    userId(){
      return this.$store.state.app.userId;
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-scrollbar {
    background-color: var(--system-menu-background);
  }
  .layout-menu {
    overflow: auto;
    align-items: center;
    height: 100%;
    border:0!important;
  }
</style>